<div class="app-shell" water-ripple>
  <app-header></app-header>

  <div class="app-container">

  <div if.bind="calendar.loading" class="loading">Loading releases...</div>
  <div if.bind="calendar.error" class="error">${calendar.error}</div>

  <div class="main-layout ${calendar.releasesExpanded && calendar.selectedDay ? 'is-expanded' : ''}" if.bind="!calendar.loading">

    <div class="panel-backdrop ${calendar.filterPanelOpen ? 'is-open' : ''}" click.trigger="calendar.closeFilterPanel()"></div>
    <div class="panel-backdrop ${calendar.selectedDay ? 'is-open' : ''}" click.trigger="calendar.closeReleasesPanel()"></div>

    <filter-panel></filter-panel>
    <calendar-grid></calendar-grid>
    <releases-panel></releases-panel>

  </div>

  <app-footer></app-footer>

  <lightbox></lightbox>
  <login-modal></login-modal>
  <legal-modal></legal-modal>
  <save-search-modal></save-search-modal>
  <profile-modal></profile-modal>
  <email-optin-modal></email-optin-modal>
  <welcome-modal></welcome-modal>
  <signup-nudge></signup-nudge>
  <subscription-limit-toast></subscription-limit-toast>
  <feedback-widget></feedback-widget>
  <source-admin-panel></source-admin-panel>
  <image-cache-admin-panel></image-cache-admin-panel>
  <users-report-admin-panel></users-report-admin-panel>
  <analytics-admin-panel></analytics-admin-panel>
  <scraper-report-admin-panel></scraper-report-admin-panel>
  <daily-releases-admin-panel></daily-releases-admin-panel>
  <config-admin-panel></config-admin-panel>
  <logs-admin-panel></logs-admin-panel>

  <button
    if.bind="!admin.isAdmin && admin.loginConfigured"
    class="admin-hotspot"
    click.trigger="admin.openLogin($event)"
    aria-label="Admin sign in"
    tabindex="-1"></button>
  </div>
</div>
